'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _addedToCartInfoModel = require('./addedToCartInfoModel');

var _addressModel = require('./addressModel');

var _brandModel = require('./brandModel');

var _cartModel = require('./cartModel');

var _cartDraftModel = require('./cartDraftModel');

var _cartErrorMessageModel = require('./cartErrorMessageModel');

var _cartSellerModel = require('./cartSellerModel');

var _cartSellerProductModel = require('./cartSellerProductModel');

var _categoryModel = require('./categoryModel');

var _categoryWithSubcategoriesModel = require('./categoryWithSubcategoriesModel');

var _deliveryModel = require('./deliveryModel');

var _deliveryProductModel = require('./deliveryProductModel');

var _discounttypeModel = require('./discounttypeModel');

var _filterCategoryModel = require('./filterCategoryModel');

var _filterCategoryItemModel = require('./filterCategoryItemModel');

var _filterModel = require('./filterModel');

var _cartDisabledSellerModel = require('./cartDisabledSellerModel');

var _mediPimDataModel = require('./mediPimDataModel');

var _newsItemModel = require('./newsItemModel');

var _newsOverviewModel = require('./newsOverviewModel');

var _newsSearchRequest = require('./newsSearchRequest');

var _orderModel = require('./orderModel');

var _orderProductModel = require('./orderProductModel');

var _orderConfirmationModel = require('./orderConfirmationModel');

var _orderOverviewItemModel = require('./orderOverviewItemModel');

var _pagingModel = require('./pagingModel');

var _productModel = require('./productModel');

var _productOverviewModel = require('./productOverviewModel');

var _productOverviewItemModel = require('./productOverviewItemModel');

var _productFilterRequest = require('./productFilterRequest');

var _productSearchRequest = require('./productSearchRequest');

var _sellerModel = require('./sellerModel');

var _sellerCategoryModel = require('./sellerCategoryModel');

var _sellerBannerModel = require('./sellerBannerModel');

var _tenantModel = require('./tenantModel');

var _totalsModel = require('./totalsModel');

var _userModel = require('./userModel');

var _helpItemModel = require('./helpItemModel');

var _newsTileModel = require('./newsTileModel');

var _sellerOverviewModel = require('./sellerOverviewModel');

var _partnershipModel = require('./partnershipModel');

var _partnershipOverviewModel = require('./partnershipOverviewModel');

var _partnershipDetail = require('./partnershipDetail');

var _stockModel = require('./stockModel');

var _stockOverviewModel = require('./stockOverviewModel');

var _sellerContactModel = require('./sellerContactModel');

var _sellerPublicModel = require('./sellerPublicModel');

var _fastOrderProductModel = require('./fastOrderProductModel');

var _productSetModel = require('./productSetModel');

var _cartProduct = require('./cartProduct');

var _productDiscountModel = require('./productDiscountModel');

var _contractModel = require('./contractModel');

var _contractDetailModel = require('./contractDetailModel');

var _filterHierarchyCategoryItemModel = require('./filterHierarchyCategoryItemModel');

var _wholesalerModel = require('./wholesalerModel');

var _outletCategoryModel = require('./outletCategoryModel');

var _outletHomePageModel = require('./outletHomePageModel');

var _rentalProductOverviewModel = require('./rentalProductOverviewModel');

var _rentalProductOverviewItemModel = require('./rentalProductOverviewItemModel');

var _rentalProductsOrderModel = require('./rentalProductsOrderModel');

var _rentalProductModel = require('./rentalProductModel');

var _rentalProductCategoryModel = require('./rentalProductCategoryModel');

var _libraryDocumentCategoryModel = require('./libraryDocumentCategoryModel');

var _libraryDocumentModel = require('./libraryDocumentModel');

var _libraryQuestionModel = require('./libraryQuestionModel');

var _deliveryInfoRentalProductModel = require('./deliveryInfoRentalProductModel');

var _contactInfoRentalProductModel = require('./contactInfoRentalProductModel');

var _rentalHistoryItemModel = require('./rentalHistoryItemModel');

var _rentalHistoryDetailModel = require('./rentalHistoryDetailModel');

var _rentalHistoryStatusItemModel = require('./rentalHistoryStatusItemModel');

var _certificateItemModel = require('./certificateItemModel');

var _packageItemModel = require('./packageItemModel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.models', []).factory('AddedToCartInfo', _addedToCartInfoModel.addedToCartInfo).factory('Address', _addressModel.address).factory('Brand', _brandModel.brand).factory('CartDraft', _cartDraftModel.cartDraft).factory('CartErrorMessage', _cartErrorMessageModel.cartErrorMessage).factory('Cart', _cartModel.cart).factory('CartSeller', _cartSellerModel.cartSeller).factory('CartDisabledSeller', _cartDisabledSellerModel.cartDisabledSeller).factory('CartSellerProduct', _cartSellerProductModel.cartSellerProduct).factory('Category', _categoryModel.category).factory('CategoryWithSubcategories', _categoryWithSubcategoriesModel.categoryWithSubcategories).factory('Delivery', _deliveryModel.delivery).factory('DeliveryProduct', _deliveryProductModel.deliveryProduct).factory('Discounttype', _discounttypeModel.discounttype).factory('FilterCategory', _filterCategoryModel.filterCategory).factory('FilterCategoryItem', _filterCategoryItemModel.filterCategoryItem).factory('Filter', _filterModel.filter)
//.factory('Identity', identity)
.factory('MediPimData', _mediPimDataModel.mediPimData).factory('NewsItem', _newsItemModel.newsItem).factory('NewsOverview', _newsOverviewModel.newsOverview).factory('NewsSearchRequest', _newsSearchRequest.newsSearchRequest).factory('Order', _orderModel.order).factory('OrderProduct', _orderProductModel.orderProduct).factory('OrderConfirmation', _orderConfirmationModel.orderConfirmation).factory('OrderOverviewItem', _orderOverviewItemModel.orderOverviewItem).factory('Paging', _pagingModel.paging).factory('Product', _productModel.product).factory('ProductOverview', _productOverviewModel.productOverview).factory('ProductOverviewItem', _productOverviewItemModel.productOverviewItem).factory('ProductFilterRequest', _productFilterRequest.productFilterRequest).factory('ProductSearchRequest', _productSearchRequest.productSearchRequest).factory('Seller', _sellerModel.seller).factory('SellerCategory', _sellerCategoryModel.sellerCategory).factory('SellerBanner', _sellerBannerModel.sellerBanner).factory('Tenant', _tenantModel.tenant).factory('Totals', _totalsModel.totals).factory('User', _userModel.user).factory('HelpItem', _helpItemModel.helpItem).factory('NewsTile', _newsTileModel.newsTile).factory('SellerOverview', _sellerOverviewModel.sellerOverview).factory('Partnership', _partnershipModel.partnership).factory('PartnershipOverview', _partnershipOverviewModel.partnershipOverview).factory('PartnershipDetail', _partnershipDetail.partnershipDetail).factory('StockOverview', _stockOverviewModel.stockOverview).factory('Stock', _stockModel.stock).factory('SellerContact', _sellerContactModel.sellerContact).factory('SellerPublic', _sellerPublicModel.sellerPublic).factory('FastOrderProduct', _fastOrderProductModel.fastOrderProduct).factory('ProductDiscount', _productDiscountModel.productDiscount).factory('ProductSet', _productSetModel.productSet).factory('CartProduct', _cartProduct.cartProduct).factory('Contract', _contractModel.contract).factory('FilterHierarchyCategoryItem', _filterHierarchyCategoryItemModel.filterHierarchyCategoryItem).factory('Wholesaler', _wholesalerModel.wholesaler).factory('ContractDetail', _contractDetailModel.contractDetail).factory('RentalProductOverview', _rentalProductOverviewModel.rentalProductOverview).factory('RentalProduct', _rentalProductModel.rentalProduct).factory('RentalProductOverviewItem', _rentalProductOverviewItemModel.rentalProductOverviewItem).factory('RentalHistoryItem', _rentalHistoryItemModel.rentalHistoryItem).factory("RentalHistoryDetail", _rentalHistoryDetailModel.rentalHistoryDetail).factory("RentalHistoryStatusItem", _rentalHistoryStatusItemModel.rentalHistoryStatusItem).factory('RentalProductsOrder', _rentalProductsOrderModel.rentalProductsOrder).factory('OutletCategory', _outletCategoryModel.outletCategory).factory('OutletHomePage', _outletHomePageModel.outletHomePage).factory('RentalProductCategory', _rentalProductCategoryModel.rentalProductCategory).factory('LibraryDocumentCategory', _libraryDocumentCategoryModel.libraryDocumentCategory).factory('LibraryDocument', _libraryDocumentModel.libraryDocument).factory('LibraryQuestion', _libraryQuestionModel.libraryQuestion).factory('ContactInfoRentalProduct', _contactInfoRentalProductModel.contactInfoRentalProduct).factory('DeliveryInfoRentalProduct', _deliveryInfoRentalProductModel.deliveryInfoRentalProduct).factory('CertificateItem', _certificateItemModel.certificateItem).factory('PackageItem', _packageItemModel.packageItem);
//import {identity} from './identityModel';
exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./common/models/index.js
// module id = 753
// module chunks = 0